export default "__VITE_ASSET__MC55jFxQ__"